var map = {
	"./countries/de-countries.json": 9218,
	"./countries/en-GB-countries.json": 70,
	"./countries/es-countries.json": 5421,
	"./countries/fr-countries.json": 4021,
	"./countries/it-countries.json": 5487,
	"./countries/nl-countries.json": 6875,
	"./de.json": 5894,
	"./en-GB.json": 3708,
	"./es.json": 6725,
	"./fr.json": 4605,
	"./it.json": 3672,
	"./nl.json": 4943
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8378;